import { useEffect } from 'react';
import { io } from 'socket.io-client';
import { useNavigate } from 'react-router-dom';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:4000';

const NotificationListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const socket = io(SOCKET_URL, {
      path: '/socket.io',
      transports: ['websocket', 'polling'],
    });

    // FIX: pages (Orders.js, dashboards) read window.socket for instant push updates,
    // but nothing ever assigned it — the realtime listeners were dead code. Expose it.
    window.socket = socket;

    socket.on('connect', () => {
      console.log('📡 Admin Socket: Connected for Global Broadcasts');
    });

    socket.on('receive_broadcast', (data) => {
      console.log('📢 New Broadcast Received (Admin View):', data);

      // Since admin might not have react-toastify, we'll use a simple alert or notification logic
      // In this specific project, let's assume they might want to see it in their own notifications page
      if (window.confirm(`📢 NEW BROADCAST: ${data.title}\n\n${data.body}\n\nView Notifications?`)) {
        navigate('/notifications');
      }
    });

    return () => {
      if (window.socket === socket) window.socket = null;
      socket.disconnect();
    };
  }, [navigate]);

  return null;
};

export default NotificationListener;
